import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const StoreBookAppointmentCTA = (_param)=> {
    var { className , labels , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "onClick"
    ]);
    return React.createElement(Button, swcHelpers.extends({}, rest, {
        className: classnames('store-book-appointment-cta-stores-v2', className),
        variant: "solid",
        onClick: onClick
    }), /*#__PURE__*/ React.createElement("span", {
        className: "store-book-appointment-cta-stores-v2__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "calendar"
    })), labels.caption);
};

export { StoreBookAppointmentCTA as default };
//# sourceMappingURL=StoreBookAppointmentCTA.js.map
